import React from 'react';
import queryString from 'query-string';
import useCookie from 'react-use-cookie';

import Heading from './renderers/Heading';
import Hero from './Hero';
import HubSpotForm from './HubSpotForm';
import MarkdownRenderer from './MarkdownRenderer';
import RelatedContent from './RelatedContent';
import ShareSheet from './ShareSheet';
import Paragraph from './renderers/Paragraph';
import Pill from './Pill';
import Section from './Section';

const MQLPage = ({
  page: { coverImage, ...page },
  form,
  location,
  relatedContent,
}) => {
  const params = queryString.parse(location.search);
  const [referrer] = useCookie('referrer', 'Direct');

  if (!page) return null;

  return (
    <React.Fragment>
      <Section>
        <Hero {...page}>
          <Pill label={page.type} size="large" />
        </Hero>
        <div className="lg:flex lg:-mx-6">
          <div className="lg:px-6 lg:w-3/5">
            {page.subTitle && (
              <Paragraph
                children={page.subTitle}
                className="font-medium text-xl"
              />
            )}
            <MarkdownRenderer {...page} />
          </div>
          <div className="lg:px-6 lg:w-2/5 my-6">
            <div className="lg:sticky lg:top-0">
              <div className="lg:-mt-12 mb-4">
                <Heading level={4}>
                  {page.formTitle
                    ? page.formTitle
                    : `Register for ${page.type.toLowerCase()}`}
                </Heading>
                <hr className="inline-block bg-cornflower border-0 h-1 rounded w-24 md:w-48" />
              </div>
              <HubSpotForm form={form} params={{ ...params, referrer }} />
            </div>
          </div>
        </div>
        <div className="flex items-center justify-between mt-6 md:-mr-3">
          <hr className="md:block bg-cornflower border-0 h-1 my-6 md:my-12 rounded w-24 md:w-48" />
          <ShareSheet title={page.title} url={location.href} />
        </div>
      </Section>

      <RelatedContent relatedContent={relatedContent} />
    </React.Fragment>
  );
};

export default MQLPage;
